import { render, staticRenderFns } from "./CreateAssignment.vue?vue&type=template&id=60451a2c&scoped=true&"
import script from "./CreateAssignment.vue?vue&type=script&lang=js&"
export * from "./CreateAssignment.vue?vue&type=script&lang=js&"
import style0 from "./CreateAssignment.vue?vue&type=style&index=0&id=60451a2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60451a2c",
  null
  
)

export default component.exports